module.exports = __webpack_public_path__ + "img/featureImg1.05c6d77a.png";